// Priority Configuration v1 — versioned weights. Never rewrite past rankings.

export const PRIORITY_CONFIG_V1 = {
  version: 'priority-config-v1',
  weights: {
    constraint: 25,
    gate: 25,
    evidenceUplift: 20,
    founderOnly: 10,
    dueAge: 10,
    allocationDrift: 10,
  },
  penalties: {
    unlinkedInternal: 12,
    productWithoutOpp: 18,
    missingData: 8,
    blocked: 10,
    duplicate: 20,
    outOfScope: 40,
  },
};

export function scoringConfigVersion(config = PRIORITY_CONFIG_V1) {
  return config.version || 'priority-config-v1';
}
